import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PeopleIcon from '@material-ui/icons/People';
import React from 'react';
import { useSelector } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  peopleIcon: {
    verticalAlign: 'text-bottom',
    margin: '0px 5px 0px 8px',
  },
  redCircle: {
    display: 'inline-block',
    height: '10px',
    width: '10px',
    borderRadius: '50%',
    backgroundColor: '#dc3754',
    marginRight: '5px',
  },
  statusBox: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('mobile')]: {
      whiteSpace: 'nowrap',
      flexWrap: 'nowrap',
      flexDirection: 'column',
    },
    [theme.breakpoints.up('mobile')]: {
      flexDirection: 'column',
      backgroundColor: theme.palette.background.light,
      width: '50%',
      margin: '0 auto',
      ...theme.mixins.borderRadius(),
      ...theme.mixins.shadow(),
    },
  },
  live: {
    fontWeight: '100',
    fontSize: '1em',
    [theme.breakpoints.down('mobile')]: {
      display: 'none',
    },
  },
  spinner: {
    [theme.breakpoints.down('mobile')]: {
      display: 'none',
    },
  },
}));

export default function StreamStatus() {
  const classes = useStyles();
  const { status, ResourceStatus } = useSelector(({ conference }) => ({
    status: conference.Status,
    ResourceStatus: conference.ResourceStatus,
  }));

  return (
    status !== 'OFFLINE' && (
      <div className={classes.statusBox}>
        {status === 'CREATING' ? (
          <div style={{ padding: '5px' }}>
            <CircularProgress className={classes.spinner} data-testid="loading-spinner-exits" />
          </div>
        ) : (
          <>
            <div>
              <span className={classes.redCircle}></span>
              <Typography className={classes.live} display="inline">
                LIVE
              </Typography>
            </div>
            <div>
              <Typography style={{ fontWeight: '100', fontSize: '1em' }} display="inline">
                <PeopleIcon className={classes.peopleIcon} style={{ fontSize: '1em' }} />
                {ResourceStatus.Viewers === 0 ? 1 : ResourceStatus.Viewers}
              </Typography>
            </div>
          </>
        )}
      </div>
    )
  );
}
